
const productsPageStore = {
    state: () => ({
        createProductPanelIsOpen: false,
        updateProductPanelIsOpen: false,
    }),
    actions: {
        openCreateProductPanel: ({commit}) => {
            commit('setCreateProductPanelIsOpen', true)
        },
        closeCreateProductPanel: ({commit}) => {
            commit('setCreateProductPanelIsOpen', false)
        },

        openUpdateProductPanel: ({commit}) => {
            commit('setUpdateProductPanelIsOpen', true)
        },
        closeUpdateProductPanel: ({commit}) => {
            commit('setUpdateProductPanelIsOpen', false)
            commit('CLEAR_ACTIVE_PRODUCT')
        },
    },
    mutations: {
        setCreateProductPanelIsOpen: (state, isOpen) => {
            state.createProductPanelIsOpen = isOpen
        },
        setUpdateProductPanelIsOpen: (state, isOpen) => {
            state.updateProductPanelIsOpen = isOpen
        },

    },
    getters: {
        getCreateProductPanelIsOpen: state => {
            return state.createProductPanelIsOpen
        },
        getUpdateProductPanelIsOpen: state => {
            return state.updateProductPanelIsOpen
        }
    }
}

export default productsPageStore